import React, { useEffect,useRef } from "react";
import { Col, Row } from "react-bootstrap";
import normatecaStore from "../../stores/normatecaStore";
import Acoordion from "./../Contenido/MenuAcoordion/Acoordion";

export default function ConsultaMateria(){
    // store - zuntand
    const {menuEncabezado,setVisMenuP} =
    normatecaStore((state) =>( { 
        menuEncabezado:state.menuEncabezado,
        setVisMenuP: state.setVisMenuP,
    })); 
    const mt = useRef(null);
    useEffect(() => {
        document.addEventListener("click", clickOutsideMt, false);
        return () => {
        document.removeEventListener("click", clickOutsideMt, false);
        };
   }, []);
   const clickOutsideMt = event => {
    if (mt.current && !mt.current.contains(event.target)) {
        setVisMenuP("mt4").catch(null);
    }
  };
    return (
        <Row className="consultamateria">
            <Col sm={4} className="width-70">&nbsp;</Col>
             <Col sm={2} id="divFloatR">
                <div className="alignSelf-center">        
                    <div id="menuMat" className="menuUnidAd" ref={mt}>
                        <Acoordion ubi="menuMat" menu={menuEncabezado[3]} indi="4"/> 
                    </div>
                </div>
            </Col>        
        </Row>
    )
}